import styled from 'styled-components'

export const FilterOrderBar = styled.div`
  display: grid;
  padding-bottom: 2rem;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
`
